function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var SearchParams = /*#__PURE__*/function () {
  function SearchParams(answers) {
    var _answers$countries, _answers$fieldsOfEduc, _answers$intakes, _answers$programLevel;
    _classCallCheck(this, SearchParams);
    this.params = {};
    if (answers.duolingoScore) {
      var duolingo = {
        'englishScore[type]': 'duolingo_english',
        'englishScore[total]': answers.duolingoScore.total
      };
      this.params = _objectSpread(_objectSpread({}, this.params), duolingo);
    } else if (answers.ieltsScore) {
      var ielts = {
        'englishScore[type]': 'ielts',
        'englishScore[l]': answers.ieltsScore.listening,
        'englishScore[r]': answers.ieltsScore.reading,
        'englishScore[s]': answers.ieltsScore.speaking,
        'englishScore[w]': answers.ieltsScore.writing
      };
      this.params = _objectSpread(_objectSpread({}, this.params), ielts);
    } else if (answers.pteScore) {
      var pte = {
        'englishScore[type]': 'pte',
        'englishScore[l]': answers.pteScore.listening,
        'englishScore[r]': answers.pteScore.reading,
        'englishScore[s]': answers.pteScore.speaking,
        'englishScore[w]': answers.pteScore.writing,
        'englishScore[total]': answers.pteScore.total
      };
      this.params = _objectSpread(_objectSpread({}, this.params), pte);
    } else if (answers.toeflScore) {
      var toefl = {
        'englishScore[type]': 'toefl',
        'englishScore[l]': answers.toeflScore.listening,
        'englishScore[r]': answers.toeflScore.reading,
        'englishScore[s]': answers.toeflScore.speaking,
        'englishScore[w]': answers.toeflScore.writing
      };
      this.params = _objectSpread(_objectSpread({}, this.params), toefl);
    } else if (answers.noEnglishScore) {
      var noEnglishScore = {
        'englishScore[type]': 'noTest',
        'englishScore[noTest]': answers.noEnglishScore.value
      };
      this.params = _objectSpread(_objectSpread({}, this.params), noEnglishScore);
    }
    if (answers.gmatScore) {
      var gmat = {
        'standardizedTests[types]': 'gmat',
        'standardizedTests[gmat][t]': answers.gmatScore.total.score,
        'standardizedTests[gmat][tp]': answers.gmatScore.total.percentile,
        'standardizedTests[gmat][v]': answers.gmatScore.verbal.score,
        'standardizedTests[gmat][vp]': answers.gmatScore.verbal.percentile,
        'standardizedTests[gmat][q]': answers.gmatScore.quantitative.score,
        'standardizedTests[gmat][qp]': answers.gmatScore.quantitative.percentile,
        'standardizedTests[gmat][w]': answers.gmatScore.analyticalWriting.score,
        'standardizedTests[gmat][wp]': answers.gmatScore.analyticalWriting.percentile
      };
      this.params = _objectSpread(_objectSpread({}, this.params), gmat);
    }
    if (answers.greScore) {
      var gre = {
        'standardizedTests[types]': 'gre',
        'standardizedTests[gre][v]': answers.greScore.verbalReasoning.score,
        'standardizedTests[gre][vp]': answers.greScore.verbalReasoning.percentile,
        'standardizedTests[gre][q]': answers.greScore.quantitativeReasoning.score,
        'standardizedTests[gre][qp]': answers.greScore.quantitativeReasoning.percentile,
        'standardizedTests[gre][w]': answers.greScore.analyticalWriting.score,
        'standardizedTests[gre][wp]': answers.greScore.analyticalWriting.percentile
      };
      this.params = _objectSpread(_objectSpread({}, this.params), gre);
    }
    if (answers.greScore && answers.gmatScore) {
      this.params['standardizedTests[types]'] = 'gre,gmat';
    }
    if (!answers.greScore && !answers.gmatScore) {
      var noStandardizedTest = {
        'standardizedTests[types]': 'noTest',
        'standardizedTests[noTest]': 'dont_have'
      };
      this.params = _objectSpread(_objectSpread({}, this.params), noStandardizedTest);
    }
    if ((_answers$countries = answers.countries) !== null && _answers$countries !== void 0 && _answers$countries.length && !answers.countries.includes('undecided')) {
      this.params = _objectSpread(_objectSpread({}, this.params), {}, {
        countries: answers.countries.join()
      });
    }
    if ((_answers$fieldsOfEduc = answers.fieldsOfEducation) !== null && _answers$fieldsOfEduc !== void 0 && _answers$fieldsOfEduc.length) {
      this.params = _objectSpread(_objectSpread({}, this.params), {}, {
        disciplines: answers.fieldsOfEducation.join()
      });
    }
    if ((_answers$intakes = answers.intakes) !== null && _answers$intakes !== void 0 && _answers$intakes.length) {
      var updatedIntakes = answers.intakes.map(function (intake) {
        var year = intake.split('-')[0];
        return "".concat(year, ":").concat(intake);
      });
      this.params = _objectSpread(_objectSpread({}, this.params), {}, {
        intakes: updatedIntakes.join()
      });
    }
    if ((_answers$programLevel = answers.programLevelFamilies) !== null && _answers$programLevel !== void 0 && _answers$programLevel.length) {
      var updatedProgramLevelFamilies = answers.programLevelFamilies.map(function (programLevelFamily) {
        return SearchParams.programLevelFamiliesMap[programLevelFamily];
      });
      this.params = _objectSpread(_objectSpread({}, this.params), {}, {
        programLevelFamilies: updatedProgramLevelFamilies.join()
      });
    }
  }
  _createClass(SearchParams, [{
    key: "toString",
    value: function toString() {
      var queryStringArray = Object.entries(this.params).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return "".concat(key, "=").concat(value);
      });
      var queryString = queryStringArray.join('&');
      return queryString;
    }
  }]);
  return SearchParams;
}();
SearchParams.programLevelFamiliesMap = {
  '1': 'primary',
  '2': 'secondary',
  '3': 'undergraduate',
  '4': 'postgraduate',
  '5': 'esl'
};